export default __webpack_public_path__ + "static/media/check-icon.a71c1ee1.svg";